import { inject, InjectionToken } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ConversationConfig, RouteConfig } from '@galaxy/conversation/core';
import { FeatureFlagService } from '@galaxy/partner';
import { ConversationChannel, PlatformLocation } from '@vendasta/conversation';
import { of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { PARTNER_ID } from '../../tokens';

export const INBOX_CONFIG_FOR_CONVERSATION = new InjectionToken<ConversationConfig>(
  '[Vendor Center Client]: Token for Conversation config',
  {
    providedIn: 'root',
    factory: function (): ConversationConfig {
      const featureFlagService = inject(FeatureFlagService);
      const authService = inject(AuthService);
      const partnerId$ = inject(PARTNER_ID);

      const userId$ = authService.currentUser$.pipe(
        map((user) => user.userId),
        filter<string>(Boolean),
        distinctUntilChanged(),
        shareReplay({
          refCount: true,
          bufferSize: 1,
        }),
      );
      const accountGroupId$ = of('');

      const country$ = of(null);

      const geographicalState$ = of('');

      const partnerBrandName$ = of('');

      const companyName$ = of('');

      const featureFlag$ = partnerId$.pipe(
        take(1),
        switchMap((partnerId) => {
          return featureFlagService.batchGetStatus(partnerId, 'default', ['inbox_tab_pcc']);
        }),
        map((featureFlags) => {
          return featureFlags['inbox_tab_pcc'];
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      const platformLocation = PlatformLocation.PLATFORM_LOCATION_VENDOR_CENTER;
      const conversationChannelsEnabled$ = of([ConversationChannel.CONVERSATION_CHANNEL_INTERNAL]);

      const routes$ = of({
        root: '',
        sendNewMessage: '/products',
        useModal: true,
      } as RouteConfig);

      const marketId$ = of('');

      return {
        userId$,
        accountGroupId$,
        country$,
        geographicalState$,
        partnerId$,
        partnerBrandName$,
        companyName$,
        featureFlag$,
        platformLocation,
        conversationChannelsEnabled$,
        routes$,
        marketId$,
        hideNewMessageButton: true,
      };
    },
  },
);
